import { createAction } from 'redux-actions'

export const signinSuccess = createAction('SIGNIN_SUCCESS')
export const signoutSuccess = createAction('SIGNOUT_SUCCESS')
export const unauthorize = createAction('UNAUTHORIZE')

export const fetchAppStateSuccess = createAction<IAppState>('FETCH_APP_STATE_SUCCESS')

export const updateEnableExecution = createAction<boolean>('UPDATE_ENABLE_EXECUTION')

export const showLoading = createAction('SHOW_LOADING')
export const hideLoading = createAction('HIDE_LOADING')

export const updateUser = createAction<IUser>('UPDATE_USER')


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/actions.ts